<template>
    <div class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
                <div style="    position: absolute;
    right: 140px;
    top: -8px;
    z-index: 1;">
                    <canvas id="msg"></canvas>
                </div>
            </div>
            <div id="print">
                <div id="printArea"
                     class="printableArea"
                     :class="{'ph':!printOn,'show':printOn}"
                     style=";position: relative;">
                    <div style="position: relative" class="invoice-body">
                        <div>
                            <div >
                                <h3 class="title">教学设备赠与合同</h3>

                            </div>
                            <div >

                                <p><b>甲方（赠出人）：上海墨帝教育科技服务有限公司</b></p>
                                <p><b>乙方（获赠人）：方新生</b></p>
                                <p><b>乙方监护人：方父亲</b></p>
                                <p><b>乙方监护人身份证号：232323455683756473</b></p>
                                <p>双方经协商，就乙方赠与甲方教学设备达成协议如下，以资共同遵守：</p>
                            </div>
                            <div >
                                <h3>一、设备信息</h3>

                                <p>甲方同意在若乙方于2020寒假班及2020春季班中，进行线上课程学习，则将以下教学设备赠与乙方：<br>
                                    设备名称：<br>
                                    □	iPad2019 32G Wifi版，序列号<span style="text-decoration: underline"> 3000 </span>元<br>
                                    □	Apple Pencil一代, 序列号<span style="text-decoration: underline"> 221 </span>元<br>
                                </p>

                                <p>
                                    设备价值<span style="text-decoration: underline"> 3221 </span>元。<br>
                                    （以下简称设备）<br>
                                </p>
                            </div>
                            <div >
                                <h3>二、双方权利义务</h3>
                                <p> 1.甲方保证赠出的设备符合教学要求。<br>
                                    2.乙方接收设备时应对设备进行检查并确认设备质量状况良好，如有异议应在接收设备当时提出。<br>
                                    3.若乙方终止线上课程学习的，实际退费或转用于线下课程部分的金额为《墨帝教育服务协议书》中约定的退费金额扣除设备价值。<br>
                                </p>

                            </div>
                            <div >
                                <h3>三、争议解决</h3>
                                <p>因本合同引起的或与本合同有关的任何争议，由合同各方协商解决，也可由有关部门调解。协商或调解不成的，应向本合同签订地有管辖权的人民法院起诉。</p>
                            </div>
                            <div >
                                <h3>五、附则</h3>
                                <p>本合同一式两份，合同各方各执一份；本合同经各方签署后生效。</p>

                            </div>
                            <div >
                                <p>签署地点：上海市青浦区</p>
                                <p>签署日期： 2020 年  02 月 10 日</p>
                            </div>
                            <div style="float: left;width: 60%">
                                <p>甲方签章：</p>
                                <p>联系方式：</p>
                            </div>
                            <div style="float: left;">
                                <p>乙方监护人（签字）：</p>
                                <p>联系方式：</p>
                            </div>

                            <div style="clear: both"></div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    export default {
        name: 'Dialog_GiftOfTeachingEquipmentForNewStudent',
        data() {
            return {
                QRCodeMsg:'234',
                printOn:true
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            //this.handleInvoiceDetail()
        },
        mounted(){
        },
        methods: {
            handleInvoiceDetail() {
                this.$wApi.send(this.$parentInfo.path, 'anotherInvoiceDetail', {
                    'invoice_id': this.$store.state.modal.data.invoice_id,
                });
            },

        }
    };
</script>
